import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../TitleBar';

import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { FusioningList } from '../TitleList';
import { selectFusionInwdata } from '../Selectors/TrackSelector/TrackSelector';
import { fetchFusionInwardlist } from '../../Store/PHPSlice/Fusioning/fusioningApi';
import { TableHeader, SearchTable, Pagination } from '../TableTemplate/index';
import TableBody2 from './table-body2';


const FusioningInwReg = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    const fusionlist = useSelector(selectFusionInwdata);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchFusionInwardlist());
    }, [dispatch]);

    // console.log("Original fusionlist:", fusionlist);


    const compData = Array.isArray(fusionlist.data2) ? fusionlist?.data2?.map((item, index) => ({
        serialNumber: index + 1,
        srno: item.ID,
        dt: item.dt,
        fmemo: item.fmemo,
        numMemo: item.numMemo,
        soId: item.soId,
        sono: item.sono,
        orderno: item.orderno,
        ctinwId: item.ctinwId,
        empId: item.empId,
        empNm: item.empNm,
        itemId: item.itemId,
        itemNm: item.itemNm,
        mcloth: item.mcloth,
        mclothNm: item.mclothNm,
        m1cloth: item.m1cloth,
        m1clothNm: item.m1clothNm,
        m2cloth: item.m2cloth,
        m2clothNm: item.m2clothNm,
        m3cloth: item.m3cloth,
        m3clothNm: item.m3clothNm,
        totqty: item.totqty,
        reqty: item.reqty,
        sts: item.sts,
        fuId: item.fuId,
        firmId: item.firmId,
        firmNm: item.firmNm,
        userId: item?.userId,
        userNm: item?.userNm,
        st_sts: item.st_sts
    })) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };


    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.fmemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.orderno?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.itemId?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    // const notFound = !dataFiltered.length;
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered?.slice()
        .sort((a, b) => b.srno - a.srno)
        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    //     // Step 2: Debug displayedData
    // console.log("displayedData:", displayedData);
    // console.log("displayedData length:", displayedData.length);

    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    const headCells = [
        { id: 'srno', label: 'SrNo' },
        { id: 'dt', label: 'Date' },
        { id: 'firmNm', label: 'Firm' },
        { id: 'fmemo', label: 'Fusion Memo' },
        // { id: 'numMemo', label: 'Numbering Memo' },
        { id: 'sono', label: 'SO No.' },
        { id: 'orderno', label: 'Order No.' },
        { id: 'empNm', label: 'Master' },
        { id: 'totqty', label: 'Total Issue Qty.' },
        { id: 'reqty', label: 'Total Return Qty.' },
        { id: 'view', label: 'View' },
        { id: 'delete', label: 'Delete' }
    ];

    if (userdata?.role === "1") {
        headCells.push({ id: 'userNm', label: 'User' });
    }

    return (
        <>
            <Titlebar data={FusioningList} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Fusioning Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={headCells}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>

                                        {
                                            displayedData?.map((row) => (
                                                <TableBody2
                                                    key={row.srno}
                                                    id={row.srno}
                                                    dt={row.dt}
                                                    numMemo={row.numMemo}
                                                    fmemo={row.fmemo}
                                                    soId={row.soId}
                                                    sono={row.sono}
                                                    ctinwId={row.ctinwId}
                                                    empId={row.empId}
                                                    empNm={row.empNm}
                                                    itemId={row.itemId}
                                                    itemNm={row.itemNm}
                                                    mcloth={row.mcloth}
                                                    mclothNm={row.mclothNm}
                                                    m1cloth={row.m1cloth}
                                                    m1clothNm={row.m1clothNm}
                                                    m2cloth={row.m2cloth}
                                                    m2clothNm={row.m2clothNm}
                                                    m3cloth={row.m3cloth}
                                                    m3clothNm={row.m3clothNm}
                                                    totqty={row.totqty}
                                                    reqty={row.reqty}
                                                    sts={row.sts}
                                                    fuId={row.fuId}
                                                    firmId={row.firmId}
                                                    firmNm={row.firmNm}
                                                    userId={row.userId}
                                                    orderno={row.orderno}
                                                    userNm={row.userNm}
                                                    st_sts={row.st_sts}
                                                    serialNumber={row.serialNumber}
                                                    selected={selected.indexOf(row.name) !== -1}
                                                    handleClick={(event) => handleClick(event, row.name)}
                                                />
                                            ))
                                        }

                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default FusioningInwReg;
